var noop = function noop() {};

export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/noop.js
// module id = ./node_modules/bootstrap-vue/esm/utils/noop.js
// module chunks = 1